import { Box } from '@mui/material';
import React, { useCallback, useState } from 'react'
import { Chip, Typography } from '@mui/material';
import { IIncomeEntry, IIncomeEntryArticle } from 'types';
import IncomeEntryArticleCard from './IncomeEntryArticleCard';
import MobileFooterLayout from '../../layout/MobileFooterLayout';
import { typographyStyles } from 'constants/styles';
import { MdInfoOutline } from 'react-icons/md';
import IncomeEntryArticleProgress from './IncomeEntryArticleProgress';

interface IncomeEntryArticleProps {
  incomeEntryData: IIncomeEntry;
  loading: boolean;
  setIncomeEntryData: React.Dispatch<React.SetStateAction<IIncomeEntry | null>>;
  nextStep: (i: IIncomeEntry) => Promise<void>;
}

export default function IncomeEntryArticle({
  incomeEntryData,
  loading,
  setIncomeEntryData,
  nextStep,
}: IncomeEntryArticleProps) {
  const [articles, setArticles] = useState<IIncomeEntryArticle[]>(incomeEntryData?.articles ?? []);
  const [openArticle, setOpenArticle] = useState<number | null>(null);

  const toggleOpen = useCallback((id: number) => {
    setOpenArticle((cur) => (cur === id ? null : id));
  }, []);

  const handleUpdateArticle = useCallback((updatedArticle: IIncomeEntryArticle) => {
    setArticles((prev) => {
      const nextArticles = prev.map((a) => (a.id === updatedArticle.id ? updatedArticle : a));
      setIncomeEntryData((prev) => {
        const updated = prev ? { ...prev, articles: nextArticles } : null;
        return updated;
      });
      return nextArticles;
    });
  }, []);

  return (
    <>
      <Box sx={{ pb: 2 }}>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={typographyStyles.monospace}
        >
          Remito {incomeEntryData?.numero_remito}
        </Typography>
        <Typography variant="h6" fontWeight={700} sx={{ mt: 0.5 }}>
          {incomeEntryData?.client?.razon_social}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Transporte: {incomeEntryData?.associated_client?.razon_social || "No especificado"}
        </Typography>

        <Chip
          icon={<MdInfoOutline />}
          label="Verificación física"
          color="secondary"
          variant="outlined"
          sx={{ mt: 1.5 }}
        />

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 1.75, lineHeight: 1.5 }}
        >
          Tildá cada fardo que llegó y completá sus datos.
        </Typography>
      </Box>
      {articles.map((a) => (
        <IncomeEntryArticleCard
          key={a.id}
          incomeEntryArticle={a}
          open={openArticle === a.id}
          storeId={incomeEntryData?.store_id}
          onToggleOpen={toggleOpen}
          onUpdateArticle={handleUpdateArticle}
        />
      ))}
      <MobileFooterLayout hideWhenKeyboardOpen mobileSpacerHeight="8rem">
        <IncomeEntryArticleProgress
          articles={articles}
          loading={loading}
          onConfirm={async () => {
            await nextStep(incomeEntryData);
          }}
        />
      </MobileFooterLayout>
    </>
  )
}
